import { render, staticRenderFns } from "./TaskChecklist.vue?vue&type=template&id=1280c0f3&scoped=true&"
import script from "./TaskChecklist.vue?vue&type=script&lang=js&"
export * from "./TaskChecklist.vue?vue&type=script&lang=js&"
import style0 from "./TaskChecklist.vue?vue&type=style&index=0&id=1280c0f3&scoped=true&lang=scss&"
import style1 from "./TaskChecklist.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1280c0f3",
  null
  
)

export default component.exports